import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import seoMeta from '../i18n/seoMeta.json';

const SITE_URL = 'https://fluxipay.com';
const LANGUAGES = ['es', 'en', 'pt', 'fr', 'it', 'de'];

export const SEOHead = () => {
  const { i18n } = useTranslation();
  const lang = LANGUAGES.includes(i18n.language) ? i18n.language : 'es';
  const meta = seoMeta[lang];

  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir = 'ltr';
  }, [lang]);

  return (
    <Helmet>
      <html lang={lang} />
      <title>{meta.title}</title>
      <meta name="title" content={meta.title} />
      <meta name="description" content={meta.description} />
      <meta name="keywords" content={meta.keywords} />
      <meta name="author" content="FluxiPay" />
      <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      <meta name="googlebot" content="index, follow" />
      <link rel="canonical" href={`${SITE_URL}/`} />

      {/* hreflang for all languages */}
      {LANGUAGES.map((l) => (
        <link key={l} rel="alternate" hrefLang={l} href={`${SITE_URL}/?lang=${l}`} />
      ))}
      <link rel="alternate" hrefLang="x-default" href={`${SITE_URL}/`} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={`${SITE_URL}/`} />
      <meta property="og:title" content={meta.og_title} />
      <meta property="og:description" content={meta.og_description} />
      <meta property="og:image" content={`${SITE_URL}/og-image.png`} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content="FluxiPay - Crypto Payment Gateway" />
      <meta property="og:site_name" content="FluxiPay" />
      <meta property="og:locale" content={meta.locale} />
      {LANGUAGES.filter((l) => l !== lang).map((l) => (
        <meta key={l} property="og:locale:alternate" content={seoMeta[l].locale} />
      ))}

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={`${SITE_URL}/`} />
      <meta name="twitter:title" content={meta.og_title} />
      <meta name="twitter:description" content={meta.og_description} />
      <meta name="twitter:image" content={`${SITE_URL}/og-image.png`} />
      <meta name="twitter:image:alt" content="FluxiPay - Crypto Payment Gateway" />
      <meta name="twitter:site" content="@fluxipay" />

      {/* Performance */}
      <link rel="dns-prefetch" href="https://ipapi.co" />
    </Helmet>
  );
};

export default SEOHead;
